import React, { useEffect, useState } from "react";
import ViewAnnouncePresenter from "./ViewAnnouncePresenter";
import { useTranslation } from "react-i18next";

interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
  setAnnounceViewData: any;
}
const ViewAnnounceController = ({
  isModalOpen,
  closeModal,
  setAnnounceViewData,
}: ModalInterface) => {
  const { t } = useTranslation();

  return (
    <div>
      <ViewAnnouncePresenter
        closeModal={closeModal}
        isModalOpen={isModalOpen}
        setAnnounceViewData={setAnnounceViewData}
        trans={t}
      />
    </div>
  );
};
export default ViewAnnounceController;
